import { render, staticRenderFns } from "./comeunity-view.vue?vue&type=template&id=56580104&scoped=true&"
import script from "./comeunity-view.vue?vue&type=script&lang=js&"
export * from "./comeunity-view.vue?vue&type=script&lang=js&"
import style0 from "./comeunity-view.vue?vue&type=style&index=0&id=56580104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56580104",
  null
  
)

export default component.exports